var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("keep-alive", [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal_size sm_size" }, [
          _c(
            "a",
            {
              staticClass: "ui_close",
              attrs: { href: "JavaScript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          ),
          _vm._v(" "),
          _c("dl", { staticClass: "modal_content no_line" }, [
            _c(
              "dt",
              { staticClass: "ellipsis" },
              [_vm._t("header", [_vm._v(_vm._s(_vm.title))])],
              2
            ),
            _vm._v(" "),
            _c(
              "dd",
              _vm._l(_vm.knowledgeInfos, function(knwldg, index) {
                return _c(
                  "dl",
                  { key: knwldg.KNOWLEDGE_ID, staticClass: "acc_quickdown" },
                  [
                    _c(
                      "dt",
                      {
                        class: { active: index == 0 },
                        on: {
                          click: function($event) {
                            return _vm.clickFileArea($event, knwldg)
                          }
                        }
                      },
                      [
                        knwldg.ICON
                          ? _c("em", { class: _vm.getIconClass(knwldg.ICON) }, [
                              _vm._v(_vm._s(knwldg.ICON))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        knwldg.IMPORTANCE_YN == "Y"
                          ? _c("em", { staticClass: "textcolor_important" }, [
                              _vm._v(
                                "[" +
                                  _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) +
                                  "]"
                              )
                            ])
                          : knwldg.MUST_READ_YN == "Y"
                          ? _c("em", { staticClass: "textcolor_must" }, [
                              _vm._v(
                                "[" +
                                  _vm._s(_vm.$t("FIELD.GLOBAL.MUSTREAD")) +
                                  "]"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                                " +
                            _vm._s(knwldg.KNOWLEDGE_TITLE) +
                            "\n                                "
                        ),
                        _c("span", { staticClass: "item-date" }, [
                          _vm._v(
                            _vm._s(knwldg.REG_USER) +
                              " (" +
                              _vm._s(knwldg.REG_DT) +
                              ")"
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    knwldg.SHOW
                      ? _c("dd", [
                          knwldg.attaches && knwldg.attaches.length >= 0
                            ? _c(
                                "div",
                                [
                                  _c("innorix-download", {
                                    attrs: {
                                      uploadId: "inno_" + knwldg.KNOWLEDGE_ID,
                                      serviceType: _vm.serviceType,
                                      attachList: knwldg.attaches
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !knwldg.attaches || knwldg.attaches.length == 0
                            ? _c("div", [
                                _c("span", [
                                  _c("em", [_vm._v("No attach files")])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          knwldg.attaches.length >= 0
                            ? _c("dl", { staticClass: "attachment_link" }, [
                                _c("dt", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "txt_link",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleLink($event)
                                        }
                                      }
                                    },
                                    [_vm._v("Having trouble downloading?")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("dd", [
                                  _c(
                                    "ul",
                                    _vm._l(knwldg.attaches, function(file) {
                                      return _c(
                                        "li",
                                        {
                                          key:
                                            file.ENC_ATTCH_FILE_SEQ +
                                            file.ENC_TOKEN
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "txt_link",
                                              attrs: { href: "javascript:" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getDownloadUrl(
                                                    file.ENC_ATTCH_FILE_SEQ,
                                                    file.ENC_TOKEN
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "ico_attach"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(file.FILE_NM) +
                                                  "\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "toastr_in_wrap" }, [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("MESSAGE.POPUP.RECOMMEND")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn_wrap" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "rdbtn_md_yes",
                                  attrs: { href: "JavaScript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toastrRecommend(
                                        knwldg.KNOWLEDGE_ID
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.YES")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "rdbtn_md_no",
                                  attrs: { href: "JavaScript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showBugReportPopup(
                                        knwldg.KNOWLEDGE_ID,
                                        knwldg.SCMS_YN
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.NO")))]
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-181aea7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181aea7d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/gspnCon/AttachFilePopupParts.vue
// module id = sDg4
// module chunks = 0